import { usePostMutation } from "@/api/swr/useMutation";
import { z } from "zod";

type Config = Parameters<typeof usePostMutation<z.ZodUndefined, z.ZodNull>>[3];

export function useStartAssessmentProgress(id: number, config: Config) {
  return usePostMutation(
    z.undefined(),
    z.null(),
    `/console/companies/${id}/start_assessment`,
    config,
  );
}
